<template>
  <div id="base-filter-episodes">
    <div class="filter-episodes">
      <div class="filter-episodes__text">
        {{ selectedShow.id != 0 ? selectedShow.name : 'Filter' }}
      </div>
      <button type="button"
              class="filter-episodes__button"
              @click="onFilterClick"
      >
        <FilterIcon v-if="!filterState" />
        <IconClose v-else />
      </button>
    </div>
    <div class="filter-episodes-card" :class="{ expanded: filterState }">
      <div class="filter-episodes-card__inner">
        <div v-if="false" class="filter-episodes-card__inner__controls">
          <button type="button" @click="filterState = false">
            <IconClose />
          </button>
        </div>
        <div class="filter-episodes-card__inner__header">
          SELECT SHOW TO FILTER EPISODES
        </div>
        <ul class="filter-episodes-card__inner__list">
          <li
            v-for="show in setShowsToFilter"
            :key="show.id"
            class="filter-episodes-card__inner__list__item"
          >
            <button
              type="button"
              :class="{ active: show.name == selectedShow.name }"
              @click="selectShow(show)"
            >
              {{ show.name }}
            </button>
            <router-link
              v-if="show.permlink != null"
              :to="{ name: 'Podcasts', params: { id: show.permlink } }"
            >
              <HyperlinkIcon />
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import FilterIcon from '@/components/svg/FilterIcon.vue';
import HyperlinkIcon from '@/components/svg/HyperlinkIcon.vue';
import IconClose from '@/components/svg/IconClose.vue';
export default {
  name: 'BaseFilterEpisodes',
  components: {
    FilterIcon,
    HyperlinkIcon,
    IconClose
  },
  props: {
    shows: {
      type: Array,
      required: true
    },
    selectedId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: () => ({
    text: 'Filter',
    filterState: false,
    selectedShow: {},
    allShowsModel: {
      id: 0,
      name: 'All Shows',
      permlink: null
    }
  }),
  computed: {
    setShowsToFilter() {
      const showsReduced = this.shows.map(e => ({ id: e.id, name: e.name, permlink: e.permlink }));
      return [...showsReduced, this.allShowsModel];
    }
  },
  watch: {
    selectedId(id) {
      this.getSelectedShow(id);
    }
  },
  mounted() {
    this.getSelectedShow(this.selectedId);
  },
  methods: {
    onFilterClick() {
      this.filterState = !this.filterState;
    },
    selectShow(show) {
      this.selectedShow = show;
      this.$emit('update:selected-id', show.id);
      setTimeout(() => {
        this.filterState = false;
      }, 400);
    },
    getSelectedShow(id) {
      const selected = this.shows.find(e => e.id == id);
      if (selected == undefined) this.selectedShow = this.allShowsModel;
      else this.selectedShow = selected;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_base-filter-episodes.scss';
</style>
